<template>
  <div class="m-5 pb-5">
    <ButtonPanel :buttonIcon="'refresh'" :click="refresh" icon="speaker_notes" :title="$t(`message.openEntries`)">
      <div v-if="openReviewEntry.isLoading.value" class="flex justify-center items-center" style="height: 120px">
        <LoadingPanel />
      </div>
      <div v-else>
        <div v-if="openReviewEntry.hasEntryInList.value">
          <ReviewEntryHeader />
          <div v-for="(entry, index) in openReviewEntry.entryList.value" :key="index" class="w-full">
            <ReviewEntryElement
              :entry="entry"
              :entryType="'OPEN'"
              :index="index"
              :length="openReviewEntry.entryList.value.length"
            />
          </div>
        </div>
        <div v-else class="px-4 py-3">
          {{ $t('message.noData') }}
        </div>
      </div>
    </ButtonPanel>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'

import LoadingPanel from '@/presentation/components/Loading/LoadingPanel.vue'
import ButtonPanel from '@/presentation/components/Panel/ButtonPanel.vue'
import ReviewEntryElement from '@/presentation/components/ReviewPost/children/ReviewEntryElement.vue'
import ReviewEntryHeader from '@/presentation/components/ReviewPost/children/ReviewEntryHeader.vue'
import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useProblemStatePresenter } from '@/presentation/composables/problem/useProblemStatePresenter'
import { useOpenReviewPostEntryPresenter } from '@/presentation/composables/reviewPost/useOpenReviewPostEntryPresenter'
import { useReviewPostPageStatePresenter } from '@/presentation/composables/reviewPost/useReviewPageStatePresenter'
import { useReviewPostPresenter } from '@/presentation/composables/reviewPost/useReviewPostPresenter'

export default defineComponent({
  components: {
    ButtonPanel,
    LoadingPanel,
    ReviewEntryHeader,
    ReviewEntryElement
  },
  setup(_, ctx) {
    const { problemId } = useProblemStatePresenter()

    const { isLightMode } = useConfigStatePresenter()
    const { initState } = useReviewPostPresenter()
    const openReviewEntry = useOpenReviewPostEntryPresenter()
    const { isFirstOpendPage, setIsFirstOpendPage } = useReviewPostPageStatePresenter()

    const refresh = () => {
      initState(problemId.value)
    }

    if (isFirstOpendPage.value) refresh()

    onMounted(() => {
      setIsFirstOpendPage(false)
    })

    return { refresh, isLightMode, openReviewEntry }
  }
})
</script>

<style lang="postcss" scoped>
.select {
  user-select: none;
}

.slide-fade-enter-active {
  transition: all 0.2s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s ease-out;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>
